import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
export const C4IUserGuide = () => {
    const [userguide, setUserguide] = React.useState('');
    React.useEffect(() => {
        fetch('C4IUserguide.md')
            .then((res) => (res.status === 200 ? res.text() : ''))
            .then((res) => setUserguide(res))
            .catch((err) => console.error(err));
    }, []);
    return React.createElement(ReactMarkdown, { rehypePlugins: [rehypeRaw] }, userguide);
};
export const SwirrlUserGuide = () => {
    const [userguide, setUserguide] = React.useState('');
    React.useEffect(() => {
        fetch('SwirrlUserguide.md')
            .then((res) => (res.status === 200 ? res.text() : ''))
            .then((res) => setUserguide(res))
            .catch((err) => console.error(err));
    }, []);
    return React.createElement(ReactMarkdown, { rehypePlugins: [rehypeRaw] }, userguide);
};
